import { Control } from 'react-hook-form';

import { MedicalProfileTabFormBean, SectionNodeViewModel } from '../../tab/MedicalProfileTab.types';
import { createEntryFieldNames, createEntryKeysFieldName } from '../../tab/MedicalProfileTab.utils';

const FIRST_ENTRY_KEY = '1';
const NO_ENTRY_NUMBER = 0;
const ENTRY_NUMBER_STEP = 1;

export const DEFAULT_ENTRY_KEYS: string[] = [FIRST_ENTRY_KEY];

export type EntryListControl = Pick<Control<MedicalProfileTabFormBean>, 'getValues' | 'setValue' | 'unregister'>;

export const getNextEntryKey = (entryKeys: string[]): string =>
   String(
      entryKeys.reduce((highest, entryKey) => Math.max(highest, Number(entryKey)), NO_ENTRY_NUMBER) + ENTRY_NUMBER_STEP
   );

export const readEntryKeys = (control: EntryListControl, entryKeysFieldName: string): string[] => {
   const storedEntryKeys = control.getValues(entryKeysFieldName);
   return Array.isArray(storedEntryKeys) ? storedEntryKeys : DEFAULT_ENTRY_KEYS;
};

export const addEntry = (control: EntryListControl, templateCode: string, node: SectionNodeViewModel): void => {
   const entryKeysFieldName = createEntryKeysFieldName(templateCode, node.sectionId);
   const entryKeys = readEntryKeys(control, entryKeysFieldName);
   control.setValue(entryKeysFieldName, [...entryKeys, getNextEntryKey(entryKeys)]);
};

export const removeEntry = (
   control: EntryListControl,
   templateCode: string,
   node: SectionNodeViewModel,
   entryKey: string
): void => {
   const entryKeysFieldName = createEntryKeysFieldName(templateCode, node.sectionId);
   const entryKeys = readEntryKeys(control, entryKeysFieldName);
   const entryFieldNames = createEntryFieldNames(templateCode, node, entryKey);
   entryFieldNames.forEach((entryFieldName) => control.setValue(entryFieldName, null));
   control.unregister(entryFieldNames);
   control.setValue(
      entryKeysFieldName,
      entryKeys.filter((existingKey) => existingKey !== entryKey)
   );
};
